import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {ClaimAccountBalanceContainerModel} from '../../../../../../models';
import {Observable} from 'rxjs';

export class AccountBalanceRequestBody {
  employee_hdr_guid: string;
}

export class AccountBalanceContainerBody {
  claim_account_hdr_guid: string;
  current_balance: number;
  pending_approval_balance: number;
}

@Injectable({
  providedIn: 'root'
})
export class ClaimAccountBalanceService extends BaseApiTemplateService<ClaimAccountBalanceContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-balances/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-balances/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'account-balances/backoffice-ep';
    this.httpClient = http;
  }

  getAccountBalance(body: AccountBalanceRequestBody, apiVisa: ApiVisa): Observable<ApiResponseModel<AccountBalanceContainerBody>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/account-balances/custom-pending-approval-claim-document-line/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/account-balances/custom-pending-approval-claim-document-line/backoffice-ep';
    }

    return this.httpClient.post<ApiResponseModel<AccountBalanceContainerBody>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

}


